module.exports = __webpack_public_path__ + "img/column_img.1663912b.png";